// extracted by mini-css-extract-plugin
export default {"paymentSection":"g9-z","disabled":"h9-z"};